<script setup lang="ts">
/**
 * UI-kit component
 * Category: Icons
 * Name: IconContainer
 * FIGMA: 'https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=3499-178817&t=ldymHtYK0zJDKBqF-4
 */
import type { IconContainerProps } from '../types/interfaces'

defineOptions({
  name: 'IconContainer',
})

withDefaults(defineProps<IconContainerProps>(), {
  is: 'span',
})
</script>

<template>
  <component
    :is="is"
    class="icon-container"
  >
    <slot />
  </component>
</template>

<style lang="scss" scoped src="../styles/_icon-container.scss" />
